import { Directive } from '@angular/core';
import { AbstractControl, NG_VALIDATORS, ValidatorFn } from '@angular/forms';

export function notZeroValidator(languageService): ValidatorFn {
  return (control: AbstractControl): {[key: string]: any}  => {
    if (control.value === '') {
      return null;
    }

    const value = parseFloat(languageService.unformatNumber(control.value));
    return value === 0 ? { notZero: true } : null;
  };
}

@Directive({
  selector: '[appNotZeroValidatorDirective]',
  providers: [{ provide: NG_VALIDATORS, useExisting: NotZeroValidatorDirective, multi: true }],
})
export class NotZeroValidatorDirective {}
